var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import PopupActions from '@ntuctech/devex-tangram/PopupActions';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const ModalActions = (props) => {
    const { children, forwardedRef, className: classNameProp } = props, others = __rest(props, ["children", "forwardedRef", "className"]);
    return (React.createElement(PopupActions, Object.assign({ ref: forwardedRef, className: clsx(classNameProp, '_ndsModalActions') }, others), children));
};
ModalActions.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    forwardedRef: PropTypes.any,
    className: PropTypes.string
};
ModalActions.defaultProps = {
    children: null,
    forwardedRef: React.createRef(),
    className: null
};
export default withForwardedRef(ModalActions);
//# sourceMappingURL=ModalActions.js.map